export default {
    editableTabsValue: "",
    editableTabs: [],
    isTab:true,
    compaireParam:{},
    pageParam:{},

    loginParam:{},
    queryWord:''
}